import { combineReducers } from 'redux';

// import fetchAuth from './authReducer';
import { authReducer } from "./authReducer";
import { pptoReducer } from './pptoReducer';
import { projectReducer } from './projectReducer';
import { pptoGastoReducer } from './pptoGastoReducer';
import { generalReducer } from './generalReducer';
import { comprasReducer } from './comprasReducer';
import { contactsReducer } from './contactsReducer';

export const rootReducer = combineReducers({
  general: generalReducer,
  auth: authReducer,
  ppto: pptoReducer,
  pptoGasto: pptoGastoReducer,
  compras: comprasReducer,
  contacts: contactsReducer,
  project: projectReducer
});